import * as React from "react";
const SvgFiBrandsEthereum = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="M19.364 12.225 12 16.577l-7.368-4.352L12 0z"
      clipRule="evenodd"
    />
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="M19.37 13.62 12 24 4.63 13.62 12 17.973z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFiBrandsEthereum;
